import { Button, Grid, Typography } from '@mui/material'

import { getFirmwareVersion, getVanityName } from '../../utils/helpers'
import useSharedStyles from '../../utils/shared.styles'
import getUseCaseMatrix from '../../utils/usecase-matrix'

import useStyles from './index.styles'

const Bullet = () => <Typography variant="body1">·</Typography>

const DeviceInfo = ({
  title,
  vanity,
  uniqueId,
  firmwareVersion = '',
  useCase,
  resourcesLink,
}: {
  title: string
  vanity: string
  uniqueId: string
  firmwareVersion: string
  useCase?: DeviceUseCaseType | ''
  resourcesLink?: string
}) => {
  const classes = useStyles
  const sharedClasses = useSharedStyles

  return (
    <Grid>
      <Typography variant="subtitle2">{title}</Typography>
      <Grid container={true} direction="row" sx={sharedClasses.centerContentVertical}>
        <Grid container={true} columnSpacing={1} size="grow" sx={sharedClasses.centerContentVertical}>
          <Typography variant="body1">{getVanityName(vanity)}</Typography>
          <Bullet />
          {getFirmwareVersion(firmwareVersion) && (
            <>
              <Grid sx={classes.pill}>
                <Typography variant="caption">v{firmwareVersion}</Typography>
              </Grid>
              <Bullet />
            </>
          )}
          {useCase && (
            <>
              <Grid sx={classes.pill}>
                <Typography variant="caption">{getUseCaseMatrix()[useCase]}</Typography>
              </Grid>
              <Bullet />
            </>
          )}
          <Typography variant="body1">
            UID:{' '}
            <Typography variant="body2" color="textSecondary" component="span">
              {uniqueId}
            </Typography>
          </Typography>
        </Grid>
        {resourcesLink && (
          <Grid
            sx={{
              width: '145px',
            }}
          >
            <Button variant="text" href={resourcesLink} component="a" target="_blank" rel="noopener noreferrer">
              View Resources
            </Button>
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}

export default DeviceInfo
